export default "__VITE_ASSET__CHPVGMPi__"